import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminExtraProductChargeScreen from "../../../container/RateAdminScreen/RateAdminExtraProductChargeScreen";
import CreateRateAdminExtraProductCharge from "../../../container/RateAdminScreen/RateAdminExtraProductChargeScreen/CreateRateAdminExtraProductCharge";

const RateAdminExtraProductChargeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.HOME}
          element={
            <RateAdminExtraProductChargeScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.CREATE}
          element={<CreateRateAdminExtraProductCharge />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.EDIT}
          element={<CreateRateAdminExtraProductCharge isEdit={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCHARGE.COPY}
          element={<CreateRateAdminExtraProductCharge isCopy={true} />}
        />
      )}
    </>
  );
};

export default RateAdminExtraProductChargeRoutes;
